import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { ListRetrieveUsuario, UsuariosApiService } from '@cei-ufg/ngx-cei-seguranca';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CeiButtonComponent, CeiPanelComponent } from '@cei-ufg/ngx-arquitetura-cei-frontend';

@Component({
  selector: 'cei-admin-usuario-detail',
  standalone: true,
  imports: [AdminPageCabecalhoComponent, CommonModule, RouterModule, CeiButtonComponent, CeiPanelComponent],
  templateUrl: './detail.component.html',
})
export class AdminUsuarioDetailComponent {
  protected readonly usuario = signal<ListRetrieveUsuario | null>(null);
  private readonly usuariosApi = inject(UsuariosApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      const data = await firstValueFrom(
        this.usuariosApi.usuarioRetrieve({ id }, 'body', false, {
          transferCache: false,
        })
      );
      this.usuario.set(data);
    }
  }
}
